var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1983_2344",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1983_2344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5897 17.4871H20.4103V17.2666C20.4103 16.5623 19.994 15.9786 19.1615 15.5153C18.3291 15.0521 17.2752 14.8204 16 14.8204C14.7248 14.8204 13.6709 15.0521 12.8385 15.5153C12.006 15.9786 11.5897 16.5623 11.5897 17.2666V17.4871ZM16 12.6666C16.5624 12.6666 17.0363 12.4739 17.4218 12.0884C17.8073 11.7029 18 11.229 18 10.6666C18 10.1042 17.8073 9.63026 17.4218 9.24479C17.0363 8.85932 16.5624 8.66659 16 8.66659C15.4376 8.66659 14.9637 8.85932 14.5782 9.24479C14.1927 9.63026 14 10.1042 14 10.6666C14 11.229 14.1927 11.7029 14.5782 12.0884C14.9637 12.4739 15.4376 12.6666 16 12.6666ZM8.10257 22.6666L5.83077 24.9384C5.49401 25.2751 5.10469 25.3525 4.6628 25.1705C4.22093 24.9884 4 24.6572 4 24.1769V6.15376C4 5.54009 4.20556 5.0277 4.61667 4.61659C5.02778 4.20548 5.54017 3.99992 6.15383 3.99992H25.8462C26.4598 3.99992 26.9722 4.20548 27.3833 4.61659C27.7944 5.0277 28 5.54009 28 6.15376V20.5128C28 21.1264 27.7944 21.6388 27.3833 22.0499C26.9722 22.461 26.4598 22.6666 25.8462 22.6666H8.10257ZM7.17947 21.3333H25.8462C26.0513 21.3333 26.2393 21.2478 26.4103 21.0769C26.5812 20.9059 26.6667 20.7179 26.6667 20.5128V6.15376C26.6667 5.94865 26.5812 5.76061 26.4103 5.58966C26.2393 5.41872 26.0513 5.33326 25.8462 5.33326H6.15383C5.94872 5.33326 5.76069 5.41872 5.58973 5.58966C5.4188 5.76061 5.33333 5.94865 5.33333 6.15376V23.1794L7.17947 21.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmIcon);
export default __webpack_public_path__ + "static/media/DM-icon.765df958c137224a9a96109edb2df7f3.svg";
export { ForwardRef as ReactComponent };